module.exports = __webpack_public_path__ + "img/06.4a05a8da.jpg";